<template>
  <div>
    <breadcrumbs :crumbs="crumbs"/>

    <form-builder :id="formId"
                  @form-loaded="formLoaded"
                  @duplicate-form="duplicateForm"
                  @remove-form="removeForm"
    />

    <duplicate-form-modal v-if="showDuplicateFormModal"
                          :duplicate-form-id="duplicateFormId"
                          @hide="showDuplicateFormModal = false"
                          @duplicate-success="formDuplicated"
    />

    <remove-form-modal v-if="showRemoveFormModal"
                       :form-id="formId"
                       @form-removed="formRemoved"
                       @display="showRemoveFormModal = $event"
    />
  </div>
</template>

<script>
  import FormBuilder from '@/components/formbuilder/FormBuilder';
  import DuplicateFormModal from '@/components/formbuilder/modals/DuplicateFormModal';
  import RemoveFormModal from '@/components/formbuilder/modals/RemoveFormModal';
  import Breadcrumbs from '@/components/Breadcrumbs'
  import {mapGetters} from "vuex";

  export default {
    data() {
      return {
        form: null,
        formId: parseInt(this.$route.params.id),
        noError: true,
        showDuplicateFormModal: false,
        duplicateFormId: null,
        showRemoveFormModal: false
      }
    },

    inject: {
      $validator: '$validator'
    },

    components: {
      FormBuilder,
      DuplicateFormModal,
      RemoveFormModal,
      Breadcrumbs
    },

    computed: {
      ...mapGetters({
        appUser: 'getUser'
      }),
      crumbs: function() {
        const crumbs = [{name:'Administrative Settings'},{name:'Form List', link:'Form Builder Index'}];
        if (this.form) {
          crumbs.push({name: this.form.name});
        }
        return crumbs
      }
    },

    methods: {
      duplicateForm() {
        this.duplicateFormId = this.formId;
        this.showDuplicateFormModal = true;
      },
      removeForm() {
        this.showRemoveFormModal = true;
      },
      formLoaded(form) {
        this.form = form;
      },
      formDuplicated(newFormId) {
        this.$router.push({name: 'Form Builder Edit', hash: '#form_sidebar_settings', params: {id: newFormId, tab: 'settings'}});
        location.reload();
      },
      formRemoved() {
        this.$router.push({name: 'Form Builder Index'});
      }
    }
  }

</script>



// WEBPACK FOOTER //
// FormBuilderEditor.vue?dc882636